import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

const LessonOwner = ({avatar, name, label}) => (
    <div className="m-assignment-user">
        <div className="m-form-label"><FormattedMessage id={label} /></div>
        <div className="m-assignment-wrapper">
            {avatar && <img className="m-assignment-img" width="24" height="24" src={avatar} alt=""/>}
            <div className="m-assignment-name">{name}</div>
        </div>
    </div>
);

LessonOwner.propTypes = {
    avatar: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
};

export default LessonOwner;
